import { Box, Grid, Divider } from '@mui/material'
import React, { useEffect, useState } from 'react'
import EmptyTableRow from 'src/Component/EmptyTableRow'
import PaginatedTable, { HeadCellI, SortOrderI } from 'src/Component/PaginatedTable'
import DataRow from './DataRow'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'src/store'
import { startPageLoader, stopPageLoader } from 'src/store/features/common/commonSlice'

import SearchInput from 'src/Component/SearchInput'
import { useGetSellerSubscriptionQuery } from 'src/api/membershipApi'
import FilterDropdown from 'src/Component/FilterDropdown'
import { SUBSCRIPTION_TYPES, SubscriptionTypeFilterI } from 'src/utils/constants'

const headCells: HeadCellI[] = [
  {
    id: 'transaction_id',
    sortable: true,
    label: 'Transaction ID',
  },
  {
    id: 'purchase_date',
    sortable: true,
    label: 'Purchase Date',
  },
  {
    id: 'expiry_date',
    sortable: true,
    label: 'Expiry Date',
  },
  {
    id: 'plan__sub_product_type',
    sortable: true,
    label: 'Type',
  },
  {
    id: 'plan__plan_name',
    sortable: true,
    label: 'Plan Name',
  },
  {
    id: 'plan__total_price',
    sortable: true,
    label: 'Total Price',
  },
  {
    id: 'purchase_by__first_name',
    sortable: true,
    label: 'Purchased By',
  },
  {
    id: 'purchase_by__user_type__name',
    sortable: true,
    label: 'User Type',
  },
  {
    id: 'status',
    sortable: true,
    label: 'Status',
  },
 
]

const SubscriptionReports = () => {
  // states
  const [page, setPage] = useState<number>(1)
  const [sortOrder, setSortOrder] = useState<SortOrderI>('asc')
  const [sortOrderBy, setSortOrderBy] = useState<string>('') // headCells[i].id
  const [subscriptionTypeFilter, setSubscriptionTypeFilter] = useState<SubscriptionTypeFilterI>('')
  const [search, setSearch] = useState<string>('')

  // hooks
  const { data: SUBSCRIPTION_RESPONSE, isFetching } = useGetSellerSubscriptionQuery(
    {
      search,
      page,
      pageSize: 10,
      type: subscriptionTypeFilter,
      sortBy: (() => {
        if (sortOrder === 'asc') {
          return sortOrderBy
        } else {
          return `-${sortOrderBy}`
        }
      })(),
    },
    { refetchOnMountOrArgChange: true },
  )
  const dispatch = useDispatch<AppDispatch>()

  // functions
  const handlePageChange = (page: number) => {
    setPage(page)
  }

  const handleSorting = (_sortOrderBy: string) => {
    setSortOrder((prevState) => {
      return prevState === 'asc' ? 'desc' : 'asc'
    })
    setSortOrderBy(_sortOrderBy)
  }

  const handleSearch = (value: string) => {
    setPage(1)
    setSearch(value)
  }

  const handleFilterChange = (e: any) => {
    console.log(e)
    if (e.target) {
      setSubscriptionTypeFilter(e.target.value)
      setPage(1)
    }
  }

  const getToolbarFilter = () => {
    return (
      <Box pr={5}>
        <Divider />
        <FilterDropdown
          label='Filter by'
          options={SUBSCRIPTION_TYPES}
          onChange={handleFilterChange}
          value={subscriptionTypeFilter}
        />
      </Box>
    )
  }

  // use effects
  useEffect(() => {
    if (isFetching) {
      dispatch(startPageLoader())
    } else {
      dispatch(stopPageLoader())
    }
  }, [isFetching])

  return (
    <Box className='pageContainer'>
      <Grid container>
        <Grid md={8} sm={12} xs={12}>
          {' '}
        </Grid>
        <Grid md={4} sm={12} xs={12}>
          <Box>
            <SearchInput hasDebounce onChange={handleSearch} />
          </Box>
        </Grid>
      </Grid>

      <Box mt={2}>
        {SUBSCRIPTION_RESPONSE && (
          <PaginatedTable
            title='Seller Subscriptions'
            headCells={headCells}
            currentPage={page}
            onPageChange={handlePageChange}
            totalPages={Math.ceil(SUBSCRIPTION_RESPONSE?.count / 10)}
            onSortClick={handleSorting}
            toolbarFilter={getToolbarFilter()}
          >
            <>
              {SUBSCRIPTION_RESPONSE?.results?.length === 0 && (
                <EmptyTableRow cellCount={headCells.length} />
              )}
              {SUBSCRIPTION_RESPONSE?.results?.map((membership) => {
                return <DataRow key={membership.id} membership={membership} />
              })}
            </>
          </PaginatedTable>
        )}
      </Box>
    </Box>
  )
}

export default SubscriptionReports
